import ApiResourceManager from '../ApiResourceManager';

export default class HostAccessManager extends ApiResourceManager {
  /**
   * Whether `token` may be kept as the session on `host`. Asked with the fresh token
   * before it is written anywhere, and with no tenant headers: the question is about
   * that token's own account, not a tenant a previous session selected.
   */
  check = ({ host, token }) =>
    this.request({
      method: 'GET',
      url: '/host-access',
      params: { host },
      headers: {
        Authorization: `Bearer ${token}`,
        'x-on-behalf-of-company': '',
        'x-on-behalf-of-franchise': '',
        'x-on-behalf-of-service-provider': '',
      },
    });
}
